import ChatIcon from '@material-ui/icons/ChatOutlined';
import HomeIcon from '@material-ui/icons/HomeOutlined';
import PeopleIcon from '@material-ui/icons/PeopleOutlined';
import SettingsIcon from '@material-ui/icons/Settings';

import { makePath } from '~/helpers';

export default [
  {
    subheader: '',
    items: [
      {
        title: 'Chats',
        href: makePath('/chats'),
        icon: ChatIcon,
        className: 'scenario1-step9 nav-menu-chats',
      },
      {
        title: 'Customers',
        href: makePath('/customers'),
        icon: PeopleIcon,
        className: 'nav-menu-customers',
      },
      {
        title: 'Chatbot',
        href: makePath('/chatbot'),
        customIcon: '/static/images/chatbot.svg',
        className: 'nav-menu-chatbot',
      },
    ],
  },
  {
    subheader: '',
    items: [
      {
        title: 'Channel Manager',
        href: makePath('/channels'),
        icon: HomeIcon,
        className: 'scenario1-step5 nav-menu-channels',
      },
      // {
      //   title: 'Pricing',
      //   href: '/pricing',
      //   icon: AttachMoneyOutlined,
      // },
      {
        title: 'Settings',
        href: makePath('/settings'),
        icon: SettingsIcon,
        className: 'nav-menu-settings',
      },
    ],
  },
];
